<template>
    <div v-if="adverts.length" class="col-12 mb-4 order-last profile-promotions">
        <div class="container-box">
            <div class="container-box-title">{{ translate.account.profileAdverts }}</div>
            <div class="container-box-content d-flex flex-row justify-content-center align-items-center flex-wrap"
                id="profile-page-adverts">
                <div class="row profile-block-wrap profile-block-wrap--main">
                    <template v-for="advert in filteredAdverts">
                        <native-ad-in-search-component v-if="advert.isNativeAd" :current-page="1" :advert="advert"
                                                       :from-profile="true"
                                                       :key="`native-in-profile-${advert.id}`"
                        ></native-ad-in-search-component>

                        <solad-in-search-component v-else-if="advert.isSolAd" :advert="advert"
                                                   :from-profile="true"
                        ></solad-in-search-component>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NativeAdInSearchComponent from "@/components/search/partials/adverts/NativeAdInSearchComponent.vue";
import SoladInSearchComponent from "@/components/search/partials/adverts/SoladInSearchComponent.vue";

const data = () => {
    return {
        isDesktop: true,
        solAds: [],
    }
}

function created() {
    this.isDesktop = utils.isDesktop();
}

function mounted() {
    this.fetchSolAds();
}

async function fetchSolAds() {
    const adsCount = _.sumBy(this.adverts, a => a.isSolAd ? 1 : 0);
    const nativeAdsIds = _.map(_.filter(this.adverts, a => a.isNativeAd), ad => ad.id);

    const [err, response] = await to(
        api.search.solads(adsCount, window.location.pathname, nativeAdsIds.join(','), true)
    );

    const ads = _.get(response, 'data.advert', []);

    if (ads.length) {
        return this.solAds = ads;
    }

    this.solAds = _.times(adsCount, this.getDefaultPlaceholderForAds);
}

function getDefaultPlaceholderForAds() {
    return {
        imageurl: "/images/soladaplaceholder.jpg",
        isDefault: true,
    };
}

export default {
    components: {SoladInSearchComponent, NativeAdInSearchComponent},
    data,
    created,
    mounted,
    methods: {
        getDefaultPlaceholderForAds,
        fetchSolAds
    },
    computed: {
        filteredAdverts() {
            const solads = _.cloneDeep(this.solAds);
            const colours = ['red', 'green', 'gold'];
            const adverts = _.cloneDeep(this.adverts);

            adverts.forEach((advert, index) => {
                if (advert.isSolAd) {
                    let solad = solads.pop();

                    if (!solad) {
                        solad = this.getDefaultPlaceholderForAds();
                    }

                    solad.isSolAd = true;
                    solad.color = _.first(colours.splice((Math.random() * colours.length) | 0, 1));

                    adverts[index] = solad;
                }

                if (advert.isNativeAd) {
                    adverts.adTagColor = _.sample(['red', 'green', 'gold']);
                }
            });

            return this.isDesktop ? adverts : adverts.slice(0, 2);
        },
        ...mapState(['translate'])
    },
    props: {
        adverts: {
            type: Array,
            default: []
        }
    }
}
</script>
